import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFields } from "store/segments/slice";
import SwitchBtn from "components/buttons/SwitchBtn";
import SearchDropdown, {
  Item,
} from "components/dropdowns/SearchDropdown/SearchDropdown";
import {
  getGamesByIdsService,
  getGamesListService,
} from "services/gamesService";
import {
  getCollectionsByIdsService,
  getGamesCollectionsListService,
} from "services/collectionsService";
import {
  getProvidersByIdsService,
  getProvidersListService,
} from "services/providersService";
import { getTagsByIdsService, getTagsListService } from "services/tagsServise";
const RulesGamesForm: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const itemPayload = useAppSelector(
    (store) => store.segments.payload?.gameRules
  );

  const payloadFull = useAppSelector((store) => store.segments.payload);

  const selectedProviderIds = itemPayload?.providerIds ?? [];
  const selectedGameIds = itemPayload?.gameIds ?? [];
  const selectedCollectionIds = itemPayload?.collectionIds ?? [];
  const selectedTagIds = itemPayload?.tagIds ?? [];

  const [selectedProviderLabels, setSelectedProvidersLabels] = useState<Item[]>(
    []
  );
  const [selectedGameLabels, setSelectedGameLabels] = useState<Item[]>([]);
  const [selectedCollectionLabels, setSelectedCollectionLabels] = useState<
    Item[]
  >([]);
  const [selectedTagLabels, setSelectedTagLabels] = useState<Item[]>([]);
  useEffect(() => {
    if (!selectedProviderIds.length) {
      setSelectedProvidersLabels([]);
      return;
    }

    const loadLabels = async () => {
      try {
        const res = await getProvidersByIdsService(selectedProviderIds);

        const items = res.map((el: any) => ({
          value: el.id,
          label: el.title || el.name,
        }));

        setSelectedProvidersLabels(items);
      } catch (error) {
        console.error("❌ Failed to load provider labels", error);
      }
    };

    loadLabels();
  }, [selectedProviderIds]);

  useEffect(() => {
    if (!selectedGameIds.length) {
      setSelectedGameLabels([]);
      return;
    }

    const loadLabels = async () => {
      try {
        const res = await getGamesByIdsService(selectedGameIds);

        const items = res.map((el: any) => ({
          value: el.id,
          label: el.title || el.name,
        }));

        setSelectedGameLabels(items);
      } catch (error) {
        console.error("❌ Failed to load game labels", error);
      }
    };

    loadLabels();
  }, [selectedGameIds]);

  useEffect(() => {
    if (!selectedCollectionIds.length) {
      setSelectedCollectionLabels([]);
      return;
    }

    const loadLabels = async () => {
      try {
        const res = await getCollectionsByIdsService(selectedCollectionIds);

        const items = res.map((el: any) => ({
          value: el.id,
          label: el.title || el.name,
        }));

        setSelectedCollectionLabels(items);
      } catch (error) {
        console.error("❌ Failed to load collection labels", error);
      }
    };

    loadLabels();
  }, [selectedCollectionIds]);

  useEffect(() => {
    if (!selectedTagIds.length) {
      setSelectedTagLabels([]);
      return;
    }

    const loadLabels = async () => {
      try {
        const res = await getTagsByIdsService(selectedTagIds);

        const items = res.map((el: any) => ({
          value: el.id,
          label: el.title || el.name,
        }));

        setSelectedTagLabels(items);
      } catch (error) {
        console.error("❌ Failed to load tag labels", error);
      }
    };

    loadLabels();
  }, [selectedTagIds]);

  const handleData = (
    key: string,
    value: string | boolean | number | number[] | string[]
  ) => {
    const existingRules = payloadFull?.gameRules ?? {};
    const updatedRule = {
      ...existingRules,
      [key]: value,
    };
    //   @ts-ignore
    dispatch(handleUpdateFields({ gameRules: updatedRule }));
  };

  const handleItemSelect =
    (key: "gameIds" | "collectionIds" | "providerIds" | "tagIds") =>
    (item: Item & { removed?: boolean }) => {
      const current = itemPayload?.[key] ?? [];
      const value = Number(item.value);

      if (item.removed) {
        handleData(
          key,
          current.filter((id: number) => id !== value)
        );
        return;
      }

      if (!current.includes(value)) {
        handleData(key, [...current, value]);
      }
    };

  const isActive = itemPayload?.isActive === 1 ? 1 : 0;

  return (
    <div className="rules-payments-wrapper">
      <div className="segment-rules-form-wrapper">
        <div className="segments-rules-form-box">
          <div className="segments-rules-multiselect">
            <SearchDropdown
              fetchService={getProvidersListService}
              label={t("providers")}
              searchQuery="title"
              payloadData={{ isActive }}
              onSelect={handleItemSelect("providerIds")}
              defaultValues={selectedProviderLabels}
            />
          </div>

          <div className="segments-rules-multiselect">
            <SearchDropdown
              fetchService={getGamesListService}
              label={t("games")}
              searchQuery="gameTitle"
              payloadData={{ isActive }}
              onSelect={handleItemSelect("gameIds")}
              defaultValues={selectedGameLabels}
            />
          </div>

          <div className="segments-rules-multiselect">
            <SearchDropdown
              fetchService={getGamesCollectionsListService}
              label={t("collections")}
              searchQuery="title"
              payloadData={{ isActive }}
              onSelect={handleItemSelect("collectionIds")}
              defaultValues={selectedCollectionLabels}
            />
          </div>

          <div className="segments-rules-multiselect">
            <SearchDropdown
              fetchService={getTagsListService}
              label={t("tags")}
              searchQuery="title"
              payloadData={{ isActive }}
              onSelect={handleItemSelect("tagIds")}
              defaultValues={selectedTagLabels}
            />
          </div>
        </div>

        <div className="segments-rules-form-box">
          <div className="segments-rules-switcher">
            <SwitchBtn
              activeTxt={t("active")}
              isActive={itemPayload?.isActive === 1}
              handleClick={() =>
                handleData(
                  "isActive",
                  itemPayload?.isActive && itemPayload?.isActive === 1 ? 0 : 1
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RulesGamesForm;
